export default __webpack_public_path__ + "sounds/framework/1GObell_R.6bde9711.mp3?6bde9711";